import ListRowLinkGroup from './ListRowLinkGroup';

const IngredientsList = ({ ingredientOptions, nextStageOptions, handleSelectIngredient }) => {
  const formatIngredients = () => {
    let ingredientOption = nextStageOptions[0]; // in the case we have only one option and its slug is not 'ingredient-selection-option'
    let wholeMealOption;
    nextStageOptions.map(opt => {
      if (opt?.slug == 'ingredient-selection-option') {
        ingredientOption = opt;
      } else if (opt?.slug == 'whole-meal-option') {
        wholeMealOption = { id: 'whole-meal', displayText: opt.name, option: opt };
      }
    });
    let ingredients = ingredientOptions.map(i => {
      return { ...i, option: ingredientOption };
    });
    wholeMealOption && ingredients.push(wholeMealOption); // make sure wholeMealOption is at the end of the list
    return ingredients;
  };

  return (
    <ListRowLinkGroup
      iterable={formatIngredients()}
      idKey="id"
      displayTextKey="displayText"
      onClick={handleSelectIngredient}
    />
  );
};

IngredientsList.propTypes = {
  ingredientOptions: PropTypes.array.isRequired,
  nextStageOptions: PropTypes.array.isRequired,
  handleSelectIngredient: PropTypes.func.isRequired,
};

export default IngredientsList;
